import React, { useState } from "react";
import "./Feedback.css";
import { Button, FormControl, Input, InputLabel, FormHelperText, TextField } from '@material-ui/core';
import db from "./firebase";
import firebase from "firebase";

function FeedBack() {
	const [userName, setUserName] = useState('');
	const [emailAddress, setEmailAddress] = useState('');
	const [selectedRating, setSelectedRating] = useState('');
	const [selectedRatingColor, setSelectedRatingColor] = useState('');
	const [feedBackMsg, setFeedBackMsg] = useState('');

	const selectedRatingStyles = {
		background: selectedRatingColor,
		color: "#fff",
		fontWeight: "bold"
	}	

	const changeSelectedRating = (ratingName, ratingColor) => {
		setSelectedRating(ratingName);
		setSelectedRatingColor(ratingColor);
	}

	const showSentFeedBack = () => {
		const sentFeedBack = document.querySelector(".feedBack__sentFeedBackMsg");

		sentFeedBack.classList.toggle("feedBack__activeSentFeedBackMsg");
	}

	const directHome = () => {
		const sentFeedBack = document.querySelector(".feedBack__sentFeedBackMsg");
		sentFeedBack.classList.toggle("feedBack__activeSentFeedBackMsg");
		window.location.href = "/";
	}

	const sendFeedBack = () => {
		db.collection("feedback").add({
			userName: userName,
			emailAddress: emailAddress,
			rating: selectedRating,
			message: feedBackMsg,
			timestamp: firebase.firestore.FieldValue.serverTimestamp()
		}).then(() => {
			showSentFeedBack();
			setUserName('');
			setEmailAddress('');
			setSelectedRating('');
			setSelectedRatingColor('');
			setFeedBackMsg('');
		})
	}

	return (
		<div className="feedBack">
			<div className="feedBack__sendFeedBackForm">
				<h1 className="feedBack_titles"> Send us your feedback </h1>
				<FormControl className="feedBack__input">
					<InputLabel> Name </InputLabel>
					<Input value={userName} onChange={event => setUserName(event.target.value)}/>
				</FormControl>
				<FormControl className="feedBack__input">
					<InputLabel> Email	 </InputLabel>
					<Input value={emailAddress} onChange={event => setEmailAddress(event.target.value)}/>
				</FormControl>
				<h2> Rate our service </h2>
				<div className="feedBack__serviceRatings">
					<div style={selectedRating === "poor" ? selectedRatingStyles : {color: "#BE202E"}} className="feedBack__serviceRatingPoor" onClick={() => changeSelectedRating("poor", "#BE202E")}> Poor </div>
					<div style={selectedRating === "fair" ? selectedRatingStyles : {color: "#F79321"}} className="feedBack__serviceRatingFair" onClick={() => changeSelectedRating("fair", "#F79321")}> Fair </div>
					<div style={selectedRating === "good" ? selectedRatingStyles : {color: "#FDEE21"}} className="feedBack__serviceRatinGood" onClick={() => changeSelectedRating("good", "#FDEE21")}> Good </div>
					<div style={selectedRating === "great" ? selectedRatingStyles : {color: "#8CC542"}} className="feedBack__serviceRatingGreat" onClick={() => changeSelectedRating("great", "#8CC542")}> Great </div>
					<div style={selectedRating === "excellent" ? selectedRatingStyles : {color: "#059347"}} className="feedBack__serviceRatingExcellent" onClick={() => changeSelectedRating("excellent", "#059347")}> Excellent </div>
				</div>
				<FormControl className="feedBack__input">
					<TextField className="feedBack__msg" value={feedBackMsg} multiline inputProps={{maxLength: 8000,}} onChange={event => setFeedBackMsg(event.target.value)} id="outlined-basic" label="Message" variant="outlined" />
					<FormHelperText> Max length is 8000 characters </FormHelperText>
				</FormControl>
				<Button variant="contained" color="primary" onClick={sendFeedBack}> Send Feedback </Button>
			</div>
			<div className="feedBack__sentFeedBackMsg">
				<div className="feedBack__sentMsgTxt"> Feedback Sent </div>
				<Button variant="contained" color="primary" className="feedBack__sentFeedBackButton" onClick={directHome}> Okay </Button>
			</div>
		</div>
	)
}

export default FeedBack;